// Mixins
import { orderMixins } from '@/app/mixins/modules/order-mixins';

// Components
const ModalGenerateCSV = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-generate-csv"*/ '@/app/views/main-view/_shared/_components/modals/modal-generate-csv/modal-generate-csv.vue');

const statusList = [
    { id: 'For delivery', name: 'For delivery' },
    { id: 'Pending Payment', name: 'Pending Payment' },
    { id: 'For cancellation', name: 'For cancellation' },
    { id: 'Cancelled', name: 'Cancelled' },
    { id: 'Out for delivery', name: 'Out for delivery' },
    { id: 'Delivered', name: 'Delivered' },
    { id: 'Refunded', name: 'Refunded' }
];

export default {
	name: 'OrdersTable',
	mixins: [ orderMixins ],
	components: { ModalGenerateCSV },
	props: {
		userId: {
			default: ''
		},
		isCardLayout:{
			default: true,
		}
	},
	data() {
		return {
			theads: [
				{ name: 'Order #', searchLabel: 'f_id', sortLabel: 'createdAt', isDesc: false, hasSearch: true, style: null},
				{ name: 'User', searchLabel: 'f_fullName', sortLabel: 'fullName', isDesc: false, hasSearch: true, style: null},
				{ name: 'Address', searchLabel: 'f_shippingAddress', sortLabel: 'shippingAddress', isDesc: false, hasSearch: true, style: null},
				{ name: 'Price', searchLabel: 'f_totalPrice', sortLabel: 'totalPrice', isDesc: false, hasSearch: true},
				{ name: 'Tracking #', searchLabel: 'f_trackingNumber', sortLabel: 'trackingNumber', isDesc: false, hasSearch: true},
				{ 
					name: "Payment Method", 
					hasPaymentMethodFilter: true,
					searchLabel: "f_paymentMethod", 
					isDesc: false, 
					style: 'width: 170px' 
				},
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasSearchableDropdown: true, optionList: statusList},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'width: 100px'}
			],
			paymentMethods: [
				{
					value: "Store credit",
					name: "Store Credit",
				},
				{
					value: "Stripe",
					name: "Credit Card",
				},
				{
					value: "Latitude Interest Free",
					name: "Latitude Interest Free",
				},
			],
			selectedPaymentMethod: '',
			actionFrom:'',
			isFromSubscription: false
		}
	},
	methods: {
		showGenerateCSVModal() {
			this.$refs.modalGenerateCSV.show();
		}
	},
	async created() {
		this.isFromSubscription = this.$route.query.actionFrom === 'user-subscription'
    },
}